import React from 'react';
import { Router, Route, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import store, { history } from '../store';

import appRoutes from '../screens/App/index';

const router = (
  <Provider store={store}>
    <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
      {appRoutes}
    </Router>
  </Provider>
)

export default router;



// WEBPACK FOOTER //
// ./app/config/routes.js